import { render, staticRenderFns } from "./CollaborationForm.vue?vue&type=template&id=4f720b61&scoped=true&"
import script from "./CollaborationForm.vue?vue&type=script&lang=js&"
export * from "./CollaborationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f720b61",
  null
  
)

export default component.exports